import * as requestFromServer from "./invoicesCrud";
import { invoicesSlice, callTypes } from "./invoicesSlice";
import { toast } from "react-hot-toast";
import { AppDispatch } from "../store";

const { actions } = invoicesSlice;

export const getFilteredInvoices = (companyId: string, data?: any) => (dispatch: AppDispatch | any) => {
  dispatch(
    actions.startCall({
      callType: callTypes.list,
    }),
  );
  return requestFromServer
    .getFilteredInvoices(companyId, data)
    .then((response) => {
      dispatch(
        actions.getFilteredInvoices({
          allInvoices: response?.data.invoices,
          page: response?.data?.page,
          total: response?.data?.total,
          size: Number(response?.data?.size),
        }),
      );
    })
    .catch((error) => {
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
          errorType: "emailNotSent",
        }),
      );
      toast.error(error?.response?.data?.message);
    });
};

export const getInvoiceLogsById = (companyId: string, invoiceId: string, invoiceLogsLimit: number) => (dispatch: any) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getInvoiceLogsById(companyId, invoiceId, invoiceLogsLimit)
    .then((response) => {
      dispatch(
        actions.invoiceLogs({
          logs: response?.data?.logs,
          invoiceLogsCount: response?.data?.logsCount,
          totalLogsCount: response?.data?.totalLogsCount,
        }),
      );
    })
    .catch((error) => {
      error.clientMessage = "Can't find invoice logs";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
